<template>
    <div>
      <!-- Actions Toolbar -->
      <div class="has-background-white rounded-lg px-md py-md mb-xxs">
        <div class="columns is-vcentered is-mobile">
          <div class="column">
            <b-button @click.prevent="exportImages" size="is-medium" type="is-light">Download All Proposal Images</b-button>
          </div>
          <div class="column is-narrow">
            <div class="is-size-7 has-text-grey-light has-text-right">
              <!-- Counts -->
              <p>{{ jobs.length }} {{ jobs.length === 1 ? 'job' : 'jobs' }} found</p>
              <p> <a href="#" @click.prevent="reloadJobs" class="has-text-info">Refresh</a> </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Results -->
      <div>
        <div class="mb-md">
          <b-table
            :data="jobs"
            :mobile-cards="false"
            :loading="loading"
            hoverable
            class="is-size-7">
            <template>
              <!-- ID -->
              <b-table-column label="Job ID" cell-class="nowrap" v-slot="props">
                <p class="has-text-grey-light">{{ props.row.id }}</p>
              </b-table-column>

              <!-- Module Name -->
              <b-table-column label="Module" cell-class="nowrap" v-slot="props">
                <p>{{ props.row.module_name }}</p>
              </b-table-column>

              <!-- Created At -->
              <b-table-column label="Generated" centered v-slot="props">
                <p>{{ $dates.utc(props.row.created_at).local().format('MMM D, h:mm A') }}</p>
              </b-table-column>

              <!-- Download Link (Image URL) -->
              <b-table-column label="Download Link" cell-class="nowrap has-text-weight-bold" centered v-slot="props">
                <span v-if="props.row.metadata && props.row.metadata.length > 0">
                  <!-- Extract the image URL from metadata -->
                  <span v-for="metadataItem in props.row.metadata" :key="metadataItem.id">
                    <a v-if="metadataItem.name === 'images_zip_file'" :href="metadataItem.value" class="has-text-info" download>Download</a>
                  </span>
                </span>
                <span v-else>Generating URL...</span>
              </b-table-column>
            </template>

            <template #empty>
              <div class="py-xxl has-text-grey has-text-centered">
                No jobs found!
              </div>
            </template>
          </b-table>
        </div>

        <!-- Add pagination component after the table -->
        <b-pagination
          :total="total"
          :current.sync="currentPage"
          :rounded="true"
          :per-page="perPage"
          @change="paginate">
        </b-pagination>
      </div>

      <!-- Export File -->
      <div v-if="zipFileUrl" class="has-background-white rounded-lg px-md py-md mb-xxs">
        <p class="has-text-centered">
          <a :href="zipFileUrl" class="button is-primary" download>Download Zip File</a>
        </p>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {},
  computed: {
    ...mapGetters(['context'])
  },
  data () {
    return {
      jobs: [],
      zipFileUrl: null,
      total: 0,
      currentPage: 1,
      perPage: 12,
      loading: false
    }
  },
  methods: {
    fetchJobs (page = 1) {
      this.loading = true
      console.log(this.context)
      console.log(this.context.route)
      const endpoint = `/jobs/?proposal_id=${this.proposal.id}&short=1&order_by=-id&page=${page}&limit=${this.perPage}`
      this.$http.get(endpoint)
        .then(response => {
          this.jobs = response.data.results.filter(job => job.module_name === 'export_proposal_images')
          this.total = response.data.count
          this.loading = false
        })
        .catch(() => {
          this.$buefy.toast.open({ type: 'is-danger', message: 'Failed to fetch jobs. Please try again.' })
          this.loading = false
        })
    },

    paginate (page) {
      this.currentPage = page
      this.fetchJobs(page)
    },

    exportImages () {
      const endpoint = this.context.route + '/proposals/' + this.proposal.id + '/export-images/'
      this.$http.get(endpoint).then(response => {
        const metadata = response.data.metadata
        if (metadata && metadata.length > 0) {
          // Find the zip file URL
          const zipFileMetadata = metadata.find(item => item.name === 'images_zip_file')
          if (zipFileMetadata) {
            this.zipFileUrl = zipFileMetadata.value
          }
        } else {
          this.$buefy.toast.open({ type: 'is-danger', message: 'No image link found in the response.' })
        }
      }).catch(() => {
        this.$buefy.toast.open({ type: 'is-danger', message: 'Failed to generate zip file. Please try again.' })
      })
    }
  },
  props: {
    proposal: {
      type: Object,
      required: true
    }
  },
  mounted () {
    this.fetchJobs(1)
  }
}
</script>
